import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost/api'
});

// Add token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
    }
    return config;
});

// Handle token expiration
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Only clear token and redirect for 401s that are from protected endpoints
        // and not during the verification process
        if (error.response?.status === 401 && 
            !error.config.url.includes('/auth/') && // Don't clear for auth endpoints
            !error.config.url.includes('/login') && 
            !error.config.url.includes('/verify-magic-link') &&
            !sessionStorage.getItem('justLoggedIn')) { // Don't clear during verification
            
            const token = localStorage.getItem('token');
            
            if (token) {
                localStorage.removeItem('token');
                delete api.defaults.headers.common['Authorization'];
                window.location.href = '/login';
            }
        }
        
        return Promise.reject(error);
    }
);

// Helper function to set auth token
export const setAuthToken = (token) => {
    if (token) {
        localStorage.setItem('token', token);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        localStorage.removeItem('token');
        delete api.defaults.headers.common['Authorization'];
    }
};

// Children Management
export const getChildren = () => {
    return api.get('/users/children');
};

api.getChildren = getChildren;

api.searchChild = (data) => {
    // Convert the full ISO date to just YYYY-MM-DD format
    const dateOnly = data.dateOfBirth.toFormat('yyyy-MM-dd');
    
    return api.post('/users/children/search', {
        firstName: data.firstName,
        lastName: data.lastName,
        dateOfBirth: dateOnly,
        gender: data.gender
    });
};

api.createChild = (data) => {
    // Convert the full ISO date to just YYYY-MM-DD format
    const dateOnly = data.dateOfBirth.toFormat('yyyy-MM-dd');
    
    return api.post('/users/children/create', {
        firstName: data.firstName,
        lastName: data.lastName,
        dateOfBirth: dateOnly,
        gender: data.gender
    });
};

api.linkChild = (childId) => {
    return api.post('/users/children/link', { childId });
};

// Admin client management endpoints
export const adminGetClient = async (clientId) => {
    const response = await api.get(`/admin/clients/${clientId}`);
    return response.data;
};

export const adminAddChildToParent = async (parentId, childId) => {
    const response = await api.post(`/admin/clients/${parentId}/children/${childId}`);
    return response.data;
};

export const adminRemoveChildFromParent = async (parentId, childId) => {
    const response = await api.delete(`/admin/clients/${parentId}/children/${childId}`);
    return response.data;
};

export const adminSearchChildren = async (query) => {
    const response = await api.get(`/admin/clients/search-children`, {
        params: { query }
    });
    return response.data;
};

export default api; 